import { Dayjs } from 'dayjs';
import dayjs from './dayjsSetup';

const isStartOfQuarter = (date: Dayjs): boolean => {
  return dayjs(date).isSame(dayjs(date).startOf('quarter'), 'day');
};

export default isStartOfQuarter;
